import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Users from './Users';
import OutletsAndRegisters from "./OutletsAndRegisters";
import StoreCredit from "./StoreCredit";
import GiftCards from "./GiftCards";
import PersonalTokens from "./PersonalTokens";
import PaymentTypes from "./PaymentTypes";
import SalesTax from "./SalesTax";
import Loyalty from "./Loyalty";
import General from "./General";
import Printers from "./Printers";
import SalesDiscount from './SalesDiscount'
const setupParent = ({ match }) => (
    <Switch>
        <Route path={`${match.url}/Users`} component={Users} />
        <Route path={`${match.url}/OutletsAndRegisters`} component={OutletsAndRegisters} />
        <Route path={`${match.url}/General`} component={General} />
        <Route path={`${match.url}/StoreCredit`} component={StoreCredit} />
        <Route path={`${match.url}/GiftCards`} component={GiftCards} />
        <Route path={`${match.url}/PersonalTokens`} component={PersonalTokens} />
        <Route path={`${match.url}/PaymentTypes`} component={PaymentTypes} />
        <Route path={`${match.url}/SalesTax`} component={SalesTax} />
		<Route path={`${match.url}/Loyalty`} component={Loyalty} />
		<Route path={`${match.url}/printers`} component={Printers} />
        <Route path={`${match.url}/SalesDiscount`} component={SalesDiscount} />
    </Switch>
);

export default setupParent;